import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { ActionItem } from "../models/SKArtifact";
import { ActionItem as ChannelActionItem } from "../models/SKChannel";
import { ActionItem as ApplicationActionItem } from "../models/SKApplication";

interface PopupMenuProps {
  className?: string; // className for styling
  getValues: () => ActionItem[] | ChannelActionItem[] | ApplicationActionItem[];
  onSelect: (value: ActionItem | ChannelActionItem | ApplicationActionItem) => void;
  align?: "left" | "right";
  highLight?: ActionItem[] | ChannelActionItem[];
}

function ActionPopup({ className, getValues, highLight, onSelect, align = "right" }: PopupMenuProps) {
  // const [showPopup, setShowPopup] = useState(false);
  const [values, setValues] = useState<ActionItem[] | ChannelActionItem[] | ApplicationActionItem[]>([]);
  const popupRef = useRef<HTMLUListElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (popupRef.current && !popupRef.current.contains(event.target as Node)) {
      setValues([]);
    }
  };

  useEffect(() => {
    if (values) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [values]);

  const togglePopup = (e: React.MouseEvent) => {
    e.stopPropagation();
    console.log("Shoing AcionItems");
    if (values.length === 0) {
      let vals = getValues();
      setValues(vals);
    } else {
      setValues([]);
    }
    // setShowPopup(!showPopup);
  };

  //   const togglePopup = () => setShowPopup(!showPopup);

  function isChannelArray(array: (ActionItem | ChannelActionItem)[]): array is ChannelActionItem[] {
    return array.length > 0 && Object.values(ChannelActionItem).includes(array[0] as ChannelActionItem);
  }
  function isContentArray(array: (ActionItem | ChannelActionItem)[]): array is ActionItem[] {
    return array.length > 0 && Object.values(ActionItem).includes(array[0] as ActionItem);
  }

  return (
    // <div className={`absolute md:relative ${className} top-0 right-0`}>
    <div className={`relative ${className}`}>
      <button onClick={togglePopup} className="p-2 m-0 text-sm text-gray-800 rounded-full bg-skseparatorgray w-9" aria-label="Options">
        •••
      </button>
      {values.length > 0 && (
        <ul ref={popupRef} className={`absolute ${align}-0 z-50 w-48 mt-2 bg-white border border-gray-300 rounded shadow-lg`}>
          {values.map((val, index) => (
            <li key={index} className="pl-4 hover:bg-gray-100">
              <Link
                to="#"
                onClick={e => {
                  e.preventDefault();
                  onSelect(val);
                  setValues([]);
                }}
                className={
                  ((highLight && isChannelArray(highLight) && highLight.includes(val as ChannelActionItem) ? " text-skred" : "") ||
                    (highLight && isContentArray(highLight) && highLight.includes(val as ActionItem) ? " text-skred" : "") ||
                    (val === ActionItem.delete || val === ActionItem.withdraw ? " text-skred" : "")) + " w-full py-2 block"
                }
              >
                {val}
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default ActionPopup;

// import React, { useState } from "react";
// import { Link } from "react-router-dom";

// interface PopupMenuProps<T extends Record<string, string | number>> {
//   enum: T;
//   className?: string; //className for styling
//   onSelect: (value: string | number) => void;
// }

// function ActionPopup<T extends Record<string, string | number>>({ enum: Enum, className, onSelect }: PopupMenuProps<T>) {
//   const [showPopup, setShowPopup] = useState(false);

//   const togglePopup = () => setShowPopup(!showPopup);

//   return (
//     <div className={`absolute md:relative ${className} top-0 right-0 `}>
//       <button onClick={togglePopup} className="p-2 m-2 text-sm text-gray-800 rounded-full bg-skseparatorgray w-9 md:m-0 md:p-2" aria-label="Options">
//         •••
//       </button>
//       {showPopup && (
//         <ul className="absolute right-0 z-50 w-48 mt-2 bg-white border border-gray-300 rounded shadow-lg">
//           {Object.values(Enum).map((action, index) => (
//             <li key={index} className="px-4 py-2 hover:bg-gray-100">
//               <Link
//                 to="#"
//                 onClick={e => {
//                   e.preventDefault();
//                   onSelect(action);
//                   console.log(`${action} clicked`);
//                 }}
//               >
//                 {typeof action === "string" ? action : Enum[action as keyof typeof Enum]}
//               </Link>
//             </li>
//           ))}
//         </ul>
//       )}
//     </div>
//   );
// }

// export default ActionPopup;
